import { Box, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { translateBackendMessage } from "../../utilities/translateBackendMessage";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const getTypeIcon = (type) => {
  switch (String(type).toUpperCase()) {
    case "S":
      return <CheckCircleIcon sx={{ color: "#22c55e", fontSize: 18 }} />;
    case "E":
      return <ErrorIcon sx={{ color: "#ef4444", fontSize: 18 }} />;
    case "W":
      return <WarningAmberIcon sx={{ color: "#f59e0b", fontSize: 18 }} />;
    default:
      return <InfoOutlinedIcon sx={{ color: "#3b82f6", fontSize: 18 }} />;
  }
};

const MessagesPanel = ({ messages = [] }) => {

  const { t, i18n } = useTranslation();
  const isEnglish = i18n.language?.startsWith("en");

  const columns = [
    {
      field: "type",
      headerName: t("log.Status"),
      width: 60,
      align: "center",
      headerAlign: "center",
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <Box sx={{ 
          display: "flex", 
          alignItems: "center", 
          justifyContent: "center", 
          width: "100%",
          height: "100%",  
        }}>
          {getTypeIcon(params.value)}
        </Box>
      ),
    },
    {
      field: "msgIdCode",
      headerName: "ID",
      width: 120,
    },
    {
      field: "msgNumber",
      headerName: "Nº",
      width: 80,
    },
    {
      field: "text",
      headerName: t("assing.message"),
      flex: 1,
      minWidth: 320,
      renderCell: (params) => translateBackendMessage(params.value, isEnglish),
    },
  ];

  return (
    <Box>
      <Box sx={{ px: 2, py: 1.5, borderBottom: "1px solid", borderColor: "divider", bgcolor: "background.subtle" }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 800, color: "text.primary" }}>
          {t("assing.message")}
        </Typography>
      </Box>

      <div style={{ height: 140, width: "100%" }}>
        <DataGrid
          rows={messages}
          columns={columns}
          density="compact"
          hideFooter
          disableRowSelectionOnClick
          getRowClassName={(params) => {
            if (params.row.type === "S") {
              return "row-status-success";
            }
            if (params.row.type === "W") {
              return "row-status-warning";
            }            
            if (params.row.type === "E") {
              return "row-status-error";
            }
            return "";
          }}          
          sx={{
            border: 0,
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "background.paper",
              borderBottom: "2px solid",
              borderColor: "divider",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: 700,
              fontSize: "0.7rem",
              color: "text.secondary",
              textTransform: "uppercase",
            },
            "& .MuiDataGrid-cell": {
              alignItems: "center",
              display: "flex",       
            },
            "& .row-status-success": {
              backgroundColor: "rgba(34, 197, 94, 0.06)",
            },
            "& .row-status-warning": {
              backgroundColor: "rgba(245, 158, 11, 0.06)",
            },
            "& .row-status-error": {
              backgroundColor: "rgba(239, 68, 68, 0.06)",
            },
          }}
        />
      </div>
    </Box>
  );
};

export default MessagesPanel;